<div class="container">
  <div class="order-box w-depth">
    <div class="order-status-box w-depth">
      <div class="order-lane">
        <div class="status-lane">
          <div class="filled-lane" [ngClass]="statusClass">
            <div class="lane-background"></div>
          </div>
          <div class="status-circle filled start">
            <div class="inside-circle">
              <div class="circle-white"></div>
            </div>
          </div>
          <div class="status-circle middle assigned" [ngClass]="{filled: order?.status > 1 && order?.status != 9}">
            <div class="inside-circle">
              <div class="circle-white"></div>
            </div>
          </div>
          <div class="status-circle middle onRoute" [ngClass]="{filled: order?.status > 2 && order?.status != 9}">
            <div class="inside-circle">
              <div class="circle-white"></div>
            </div>
          </div>
          <div class="status-circle middle arrived" [ngClass]="{filled: order?.status > 3 && order?.status != 9}">
            <div class="inside-circle">
              <div class="circle-white"></div>
            </div>
          </div>
          <div class="status-circle end" [ngClass]="{filled: order?.status > 4 && order?.status != 9}">
            <div class="inside-circle">
              <div class="circle-white"></div>
            </div>
          </div>
        </div>
        <div class="status-text">
          <span *ngIf="order">{{'ORDERSTATUS.' + statuses[order?.status] |translate}}</span>
        </div>
      </div>
      <div class="cancel-box" *ngIf="order && order.status < 3">
        <button class="w-link-btn" (click)="cancelOrder()">{{'ORDERDETAILS.CANCELORDER' | translate}}</button>
      </div>
    </div>
    <div class="details-box">
      <div class="order-details-box" [ngClass]="{'no-driver': !(order && order.driver && order.status < 6)}">
        <div class="order-details w-depth">
          <div class="order-number" *ngIf="order?.orderNumber">{{'ORDER' | translate}} &#35;{{order?.orderNumber}}</div>
          <div class="order-number" *ngIf="!order?.orderNumber">{{'ORDERDETAILS.GENERATING' | translate}}</div>
          <div class="order-desc">
            <div class="fuel-type">{{order?.specs?.product?.name}}</div>
            <div class="delivery-time" *ngIf="order?.deliveryHour">
              {{'ORDERDETAILS.DELIVERYTIME' | translate}}: {{order.deliveryHour}}
            </div>
          </div>
          <div class="order-total" *ngIf="order">
            {{'TOTAL' | translate}}: {{order?.totals.total| toFixNumber | currency}}&#42;
            <a *ngIf="order.status == 5" class="w-link-btn receipt"
               [routerLink]="['/account/orders/receipt/' + order?.id]">
              {{'ORDERDETAILS.VIEWRECEIPT' | translate}}
            </a>
          </div>
        </div>
      </div>
      <div class="driver-details-box" *ngIf="order && order.driver && order.status < 6">
        <div class="driver-details w-depth">
          <div class="driver-image">
            <img src="./assets/images/driver-default.png">
          </div>
          <div class="driver-greetings">{{driverGreeting}}</div>
        </div>
      </div>
    </div>
    <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
  </div>
  <div class="send-me-app-container">
    <div class="send-me-app-box">
      <app-loader-lock [displayLoader]="sendAppLoader"></app-loader-lock>
      <div class="inner-box">
        <div class="send-me-text">{{'SENDMEAPP'| translate}}</div>
        <div class="send-me-input">
          <input [placeholder]="'ENTERPHONE' | translate" [title]="'ENTERPHONE' | translate"
                 [textMask]="{mask: phoneMask}" [(ngModel)]="sendMeAppPhone">
        </div>
        <div class="send-me-btn">
          <button (click)="sendMeApp(sendMeAppPhone)"><i class="wahii-icon-request"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>
